import { LocalStorage, LOCAL_STORAGE_KEYS } from 'utils';

export function writeExpressDesignerSegment<T>(segment: string, data: Record<string, T>): void {
  try {
    const existing = JSON.parse(LocalStorage.getItem(LOCAL_STORAGE_KEYS.EXPRESS_DESIGNER) ?? '{}');

    LocalStorage.setItem(LOCAL_STORAGE_KEYS.EXPRESS_DESIGNER, JSON.stringify({ ...existing, [segment]: data }));
  } catch {
    LocalStorage.setItem(LOCAL_STORAGE_KEYS.EXPRESS_DESIGNER, JSON.stringify({ [segment]: data }));
  }
}
